import React, { useContext } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import { MenuButton } from './MenuButton';
import { AppLogo } from './AppLogo';
import { UserInfo } from './UserInfo';
import { JiraFabWithDialog } from './../Jira';
import PlanDetails from './PlanDetails';
import { UserContext } from '../UserContext';
import {
  headerConfigKeys,
  onboardingHeaderConfig,
} from "../../Enums/headerConfig";
import RedirectToButton from "../Dashboard/RedirectToButton";
import BasicPlanButton from './BasicPlanButton';
import { useRouteMatch } from 'react-router-dom';


const useStyles = makeStyles((theme) => ({
  gridRoot: {
    flexGrow: 1,
  },
  appBar: {
    color: theme.palette.primary.dark,
    backgroundColor: theme.palette.background.paper,
    transition: theme.transitions.create('width'),
    [theme.breakpoints.down('md')]: {
      height: 147,
    },
    [theme.breakpoints.up('md')]: {
      height: 80,
    },
    boxShadow: '0px 0px 10px rgba(45, 96, 137, 0.5)',
  },
  userDetails: {
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
  },
}));

export function Header() {
  const classes = useStyles();
  const { user } = useContext(UserContext);
  const isAMSSupportPending = user.isAMSSupportPending();
  const role = user.getTopRole();
  const isRoleAllowed =
    role && (role === 'ceo' || role === 'super-user') ? true : false;
  const tenant = user.getTenant();
  const sso = user.getSSO();
  const isSiaaAgency = user.isSiaaAgency();
  const isSSOUser = sso === true || sso === "true" ? true : false;
  const doesNotHaveTenant = isSiaaAgency && isSSOUser && !tenant;

  const siaaConnectConfig = onboardingHeaderConfig.filter(
    (config) => config.key === headerConfigKeys.SIAA_CONNECT
  )[0];

  const gridPoints = {
    md: 6,
    lg: 6,
    xl: 6,
  };
  const match = useRouteMatch();
  const isWaitingArea = match.path && match.path.startsWith('/agencyIQ/waitingArea');

  return (
    <>
      <AppBar position="sticky" className={classes.appBar}>
        <Toolbar>
          <div className={classes.gridRoot}>
            <Grid container spacing={2} justify="space-between">
              <Grid
                item
                md={gridPoints.md}
                lg={gridPoints.lg}
                xl={gridPoints.xl}
                spacing={1}
                justify="flex-start"
                align="center"
                container
              >
                {!isWaitingArea && <MenuButton doesNotHaveTenant={doesNotHaveTenant} />}
                <AppLogo doesNotHaveTenant={doesNotHaveTenant} noLink={isWaitingArea}/>
              </Grid>
              <Grid
                item
                md={gridPoints.md}
                lg={gridPoints.lg}
                xl={gridPoints.xl}
                className={classes.userDetails}
              >
                {isAMSSupportPending && <BasicPlanButton />}
                {isSiaaAgency && siaaConnectConfig && (
                  <>
                    {!isWaitingArea && (
                      <RedirectToButton
                        key={siaaConnectConfig.key}
                        config={siaaConnectConfig}
                      />
                    )}
                  </>
                )}
                {!doesNotHaveTenant && <PlanDetails />}
                {!isWaitingArea && <UserInfo doesNotHaveTenant={doesNotHaveTenant} />}
              </Grid>
            </Grid>
          </div>
        </Toolbar>
      </AppBar>
      {!doesNotHaveTenant && (
        <>
          <JiraFabWithDialog />
        </>
      )}
    </>
  );
}
